import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import Nav from './components/Nav';
import ExpertAnswer from './components/ExpertAnswer';
import MedicationGuidance from './components/MedicationGuidance';
import ExpectHelp from './components/ExpectHelp';
import request from '@/utils/request';
import { officialList, expertInstitution } from '@/api';
import { mapMutations } from 'vuex';
import { fileViewer } from '@/utils/utils';
export default {
  components: {
    Nav: Nav,
    ExpertAnswer: ExpertAnswer,
    MedicationGuidance: MedicationGuidance,
    ExpectHelp: ExpectHelp
  },
  data: function data() {
    return {
      clinicalGuidelineList: [],
      fileViewer: fileViewer,
      loaded: false,
      institutionList: [],
      //合作机构
      expertList: [],
      //专家助力
      searchText: ''
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(['UPDATE_SEARCH_VALUE', 'UPDATE_SCANIMG', 'UPDATE_ARTICLE_URL'])), {}, {
    queryOfficialList: function queryOfficialList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loaded = true;
              params = {
                pageNum: 1,
                pageSize: 10,
                catCodes: 'clinical_guideline'
              };
              _context.next = 4;
              return request.get(officialList, {
                params: params
              });
            case 4:
              res = _context.sent;
              _this.loaded = false;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              _this.clinicalGuidelineList = res.obj.rows || [];
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryExpertInstitution: function queryExpertInstitution() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return request.get(expertInstitution);
            case 2:
              res = _context2.sent;
              if (!(res.code != 0 || !res.obj)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              _this2.institutionList = res.obj.institutionList || [];
              _this2.expertList = res.obj.expertList || [];
              // const scanImg = { miniProgramImg: res.obj.miniProgramImg, customerServiceImg: res.obj.customerServiceImg }
              // this.UPDATE_SCANIMG(scanImg)
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    search: function search() {
      this.UPDATE_SEARCH_VALUE(this.searchText);
      this.$router.push('/expertAnswer');
    },
    redirectUrl: function redirectUrl(id) {
      this.$router.push({
        path: '/article',
        query: {
          id: id
        }
      });
    }
  }),
  mounted: function mounted() {
    this.queryOfficialList();
    this.queryExpertInstitution();
  }
};